let ReceiveStoryDataHandler = function(){

};

ReceiveStoryDataHandler.prototype.isSupport = function(data){
    this.data = data;
    if(this.data.id && this.data.mediaIds && data.statusName && this.data.mediaIds.length > 0){
        return true;
    }
    return false;
};

ReceiveStoryDataHandler.prototype.handle = function (call) {
    let activitiConfName = window.sysConfigGetValueByKey("receive.story.data.handler.status.names.hide", "activitiTreeRoot-xlc-sczxwxlc");
    //不是配置里的状态就不需要加载按钮
    let statusNames = window.sysConfigGetValueByKey("receive.story.data.handler.status.names.btn.load", "返回修改").split(",");
    let object = {
        params : {
            activitiConfName,
            hideBtn: statusNames.indexOf(this.data.statusName) === -1
        },
        configName :"receiveEditor",
        id : this.data.id,
    };
    call(object);
};

export default ReceiveStoryDataHandler;